import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
// import Display3DVIew from '@/views/Display3DVIew.vue'

Vue.use(VueRouter)

const routes = [
  // 重定向根路径到 /Home
  {
    path: '/',
    redirect: '/Home'
  },
  // 捕获所有未定义路径并重定向到 /Home
  // {
  //   path: '*',
  //   redirect: '/Home'
  // },
  {
    path: '/Home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('../views/test3.vue')
  },
  {
    path: '/Display/:id',
    name: 'display',
    component: () => import('../views/DisplayVIew.vue')
  },
  {
    path: '/EditPanorama/:id',
    name: 'editPanorama',
    component: () => import('../views/EditPanorama.vue')
  },
  {
    path: '/ProjectList',
    name: 'ProjectList',
    component: () => import('../views/ProjectList.vue')
  },
  {
    path: '/ManagerView',
    name: 'ManagerView',
    component: () => import('../views/ManagerView.vue')
  },
  {
    path: '/ProjectEdit/:id',
    name: 'ProjectEdit',
    component: () => import('../views/ProjectEdit.vue')
  },
  {
    path: '/Publish',
    name: 'Publish',
    component: () => import('../views/Publish.vue')
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../views/LoginView.vue')
  },
]

const router = new VueRouter({
  mode: 'history', // 使用历史模式
  routes
})

export default router
